import { Locale } from 'modules/i18n';

export const statsTableTranslation = {
  [Locale.en]: {
    country: 'Country',
    noRequests: 'No requests',
    requests: 'Requests',
    volume: 'Volume',
  },
};
